<template>
  <Modal :name="$options.name"
         @close="clearForm"
         :is-loading="isLoading"
         is-full-screen
         title="Hozzáadás a tervhez">
    <template #body>
      <div class="mb-5">
        <!--        <div class="columns has-background-grey-lighter">-->
        <!--          <div class="column has-text-weight-bold">-->
        <!--            Kiválasztva-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="columns has-background-grey-light">
          <div class="column has-text-weight-bold">Személy</div>
          <div class="column">{{ getSelectedMemberName }}</div>
        </div>
        <div class="columns has-background-grey-lighter">
          <div class="column has-text-weight-bold">Lista</div>
          <div class="column">{{ getSelectedListName }}</div>
        </div>
      </div>
      <b-steps v-model="activeStep"
               :animated="true"
               :rounded="true"
               :has-navigation="false">
        <b-step-item step="1"
                     label="Ellenőrizendő személy kiválasztása"
                     :clickable="false">
          <h1 class="title has-text-centered">Ellenőrizendő személy kiválasztása</h1>
          <div v-if="true">
            <b-table
              :data="memberList"
              paginated
              per-page="5"
              :row-class="(row, index) => {
                      return row.id === form.selectedMemberID
                        ? 'has-background-success has-text-white'
                        : ''
                    }"
            >
              <b-table-column field="name"
                              label="Név"
                              searchable
                              v-slot="props">
                {{ props.row.name }}
              </b-table-column>
              <b-table-column field="membership_number"
                              label="Tagszám"
                              searchable
                              v-slot="props">
                {{ props.row.membership_number }}
              </b-table-column>
              <b-table-column field="id"
                              label="Kiválasztás"
                              v-slot="props">
                <b-button @click="selectMember(props.row.id)"
                          icon-left="check"
                          title="Kiválasztás"
                          type="is-primary"></b-button>
              </b-table-column>
            </b-table>
          </div>
          <h2 v-else-if="!isLoading"
              class="title is-3">Nem takálható személy</h2>
          <BasicLoading class="mt-6"
                        :is-active="isLoading"/>
        </b-step-item>
        <b-step-item step="2"
                     label="Lista/Cég kiválasztása"
                     :clickable="false">
          <h1 class="title has-text-centered">Személy lista kiválasztás</h1>
          <div v-if="true">
            <b-field label="">
              <b-select v-model="form.selectedListID"
                        placeholder="Válassz egy listát"
                        expanded>
                <option v-for="(item, index) of planList"
                        :key="`inspectionPlanAddMemberModalPlanListSelector_${index}`"
                        :value="item.id">{{ item.name }}
                </option>
              </b-select>
            </b-field>
            <div>
              <h1 class="title has-text-centered">Cégek hozzáadása (opcionális)</h1>
              <b-field v-for="(firm, index) in tmpFirms"
                       :key="`InspectionPlanAddMemberModalStep2Firm_${index}`">
                <b-checkbox v-model="form.selectedFirms[firm.id]">{{ firm.name }}</b-checkbox>
                <b-select v-if="form.selectedFirms[firm.id]"
                          v-model="form.selectedFirmsList[firm.id]"
                          placeholder="Válassz egy listát"
                          expanded>
                  <option v-for="(item, index) of firm.lists"
                          :key="`inspectionPlanAddMemberModalPlanListSelectorStep2_${index}`"
                          :value="item.id">
                    {{ item.name }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
          <h2 v-else-if="!isLoading"
              class="title is-3">Nincs találat</h2>
          <BasicLoading class="mt-6"
                        :is-active="isLoading"/>
        </b-step-item>
        <b-step-item step="3"
                     label="Összesítés, megerősítés"
                     :clickable="false">
          <h1 class="title has-text-centered">Kapcsolt cégek</h1>
          <div v-if="Object.keys(form.selectedFirms).length > 0">
            <div v-if="activeStep === 2"
                 class="mb-5">
              <div v-for="(selectedFirmID, index) in Object.keys(form.selectedFirms).filter(key => form.selectedFirms[key] !== false)"
                   :key="`InspectionPlanAddMemberModalStep3SelectedFirm_${index}`"
                   :class="{
                     'columns has-background-grey-light': index % 2 === 0,
                     'columns has-background-grey-lighter': index % 2 === 1
                   }">
                <div class="column has-text-weight-bold">{{
                    tmpFirms.find(firm => firm.id === selectedFirmID).name
                  }}
                </div>
                <div class="column">{{
                    tmpFirms.find(firm => firm.id === selectedFirmID).lists.find(item => item.id === form.selectedFirmsList[selectedFirmID]).name
                  }}
                </div>
              </div>
            </div>
          </div>
          <h2 v-else-if="!isLoading"
              class="title is-3">Nincs kapcsolt cég (csak személy rögzítése)</h2>
          <BasicLoading class="mt-6"
                        :is-active="isLoading"/>
        </b-step-item>
      </b-steps>

    </template>
    <template #footer>
      <b-button v-if="activeStep === 1"
                type="is-primary"
                @click="backToFirstStep">
        Vissza
      </b-button>
      <b-button v-if="activeStep === 2"
                type="is-primary"
                @click="activeStep--">
        Vissza
      </b-button>
      <b-button v-if="(activeStep === 0 && !!form.selectedMemberID) || activeStep === 1"
                type="is-primary"
                :disabled="activeStep === 1 && !canGoFinalStep"
                @click="activeStep++">
        Tovább
      </b-button>
      <b-button v-if="activeStep === 2"
                type="is-primary"
                @click="save">
        Mentés
      </b-button>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Modals/common/BasicModal'
import BasicLoading from '@/components/Loading'

export default {
  name: 'InspectionPlanAddMemberModal',
  components: {
    Modal,
    BasicLoading,
  },
  data () {
    return {
      form: {
        selectedListID: null,
        selectedMemberID: null,
        selectedFirms: {},
        selectedFirmsList: {},
      },
      activeStep: 0,
      isLoading: false,
      tmpFirms: [
        {
          id: '1',
          name: 'Firm 1',
          currentList: null,
          lists: [{ id: '11', name: 'asd' }, { id: '22', name: 'asd222' }],
        },
        {
          id: '2',
          name: 'Firm 2',
          currentList: { id: '33', name: 'asd333' },
          lists: [{ id: '33', name: 'asd' }, { id: '44', name: 'asd222' }],
        },
        {
          id: '3',
          name: 'Firm 3',
          currentList: null,
          lists: [{ id: '55', name: 'asd' }, { id: '66', name: 'asd222' }],
        },
        {
          id: '4',
          name: 'Firm 4',
          currentList: null,
          lists: [{ id: '77', name: 'asd' }, { id: '88', name: 'asd222' }],
        },
        {
          id: '5',
          name: 'Firm 5',
          currentList: null,
          lists: [{ id: '99', name: 'asd' }, { id: '100', name: 'asd222' }],
        },
      ],
    }
  },
  methods: {
    backToFirstStep () {
      this.activeStep = 0
      this.form.selectedListID = null
      this.form.selectedFirms = {}
      this.form.selectedFirmsList = {}
    },
    selectMember (memberID) {
      this.form.selectedMemberID = memberID
      this.activeStep++
    },
    async save () {
      this.isLoading = true
      const response = await this.$store.dispatch('addMemberToInspectionPlan', {
        memberID: this.form.selectedMemberID,
        listID: this.form.selectedListID,
      })
      if (response) {
        if (this.currentListID === this.form.selectedListID) {

        }
        await this.addItemToTableData(response)
        this.$store.dispatch('closeModal', this.$options.name)
        this.clearForm()
      }
      this.isLoading = false
    },
    clearForm () {
      this.form.selectedListID = null
      this.form.selectedMemberID = null
    },
  },
  computed: {
    addItemToTableData () {
      return this.$store.state.modal.modalPayloadData[this.$options.name]?.addItemToTableData
    },
    currentListID () {
      return this.$store.state.modal.modalPayloadData[this.$options.name]?.currentListID
    },
    memberList () {
      return this.$store.state.modal.modalPayloadData[this.$options.name]?.memberList
    },
    planList () {
      return this.$store.state.modal.modalPayloadData[this.$options.name]?.planList
    },
    getSelectedMemberName () {
      return this.memberList?.find(item => Number(item.id) === Number(this.form.selectedMemberID))?.name || '-'
    },
    getSelectedListName () {
      return this.planList?.find(item => Number(item.id) === Number(this.form.selectedListID))?.name || '-'
    },
    canGoFinalStep () {
      const hasNonSelectedListForSelectedFirm =
        Object.keys(this.form.selectedFirms)
          .filter(key => this.form.selectedFirms[key])
          .find(key => !this.form.selectedFirmsList[key])
      return !!this.form.selectedListID && !!this.form.selectedMemberID && !hasNonSelectedListForSelectedFirm
    },
  },
  watch: {
    currentListID: function (newVal, prevVal) {
      this.form.selectedListID = newVal
    },
  },
}
</script>

<style scoped>

</style>
